module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEvSURBVEhL7dItSANhHMfxc5sTDZYhGERQxCBWsVoEQYQVsyCCSRBWFsbA4EswrJkEi1qtIohpsGowaBgbiMEgIr4hc35/8x4Y8iD3bI+mfeEDdwf3f7bnuaDTfxbDMs4Q1wOfTaOEemgNXhrAPmoww+UebZWAfuUDmgcbFbTcDC5hGyzr6IdzQziCbagxh1E4lUQWT7ANlSK24dwUbmAbamj4KpwaxibG8QbbYCOFyPUijxfo5SVshdc/HaMHXYiUDtFsxzs+cYdB6LNrHr6CCTi1Ab18jjEchvcFLIbXVeSgRZ3TQWnIaePue8gjPjCJPeyi5bSf19AiaT2gDMy/irzXvzUPDSyjD924wi28dQItou3YgQ5c5+GtETxDi8grFuC1WVzgAPqiOv1VQfAFSjFt1nMshngAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-saw/dark/24.png
// module id = 2396
// module chunks = 2